import { useEffect, useRef, useState } from "react";

const CURSOR_SRC = `${process.env.PUBLIC_URL || ""}/cursor/bunnyman.webp`;

export const CustomCursor = () => {
  const [enabled, setEnabled] = useState(false);
  const [imgOk, setImgOk] = useState(true);
  const [active, setActive] = useState(false);
  const cursorRef = useRef(null);
  const pos = useRef({ x: -100, y: -100 });
  const target = useRef({ x: -100, y: -100 });

  useEffect(() => {
    const fine = window.matchMedia("(pointer: fine)").matches;
    const reduce = window.matchMedia("(prefers-reduced-motion: reduce)").matches;
    if (!fine || reduce) return undefined;
    setEnabled(true);
    document.body.classList.add("custom-cursor");

    const onMove = (e) => {
      target.current = { x: e.clientX, y: e.clientY };
    };
    const onOver = (e) => {
      setActive(Boolean(e.target.closest("a, button, [role='button'], [data-cursor='hover']")));
    };
    let rafId;
    const loop = () => {
      pos.current.x += (target.current.x - pos.current.x) * 0.22;
      pos.current.y += (target.current.y - pos.current.y) * 0.22;
      if (cursorRef.current) {
        cursorRef.current.style.transform = `translate(${pos.current.x}px, ${pos.current.y}px) translate(-50%, -50%)`;
      }
      rafId = requestAnimationFrame(loop);
    };
    window.addEventListener("mousemove", onMove, { passive: true });
    document.addEventListener("mouseover", onOver, { passive: true });
    rafId = requestAnimationFrame(loop);
    return () => {
      document.body.classList.remove("custom-cursor");
      window.removeEventListener("mousemove", onMove);
      document.removeEventListener("mouseover", onOver);
      cancelAnimationFrame(rafId);
    };
  }, []);

  if (!enabled) return null;

  return (
    <div
      ref={cursorRef}
      data-testid="custom-cursor"
      className="pointer-events-none fixed left-0 top-0 z-[9999]"
      aria-hidden="true"
    >
      <div
        className="flex items-center justify-center transition-transform duration-300 ease-out"
        style={{ transform: `scale(${active ? 1.5 : 1})` }}
      >
        {imgOk ? (
          <img
            src={CURSOR_SRC}
            alt=""
            width={32}
            height={32}
            className="h-8 w-8 select-none object-contain"
            style={{ filter: "invert(88%) sepia(6%) saturate(120%) hue-rotate(10deg)" }}
            onError={() => setImgOk(false)}
            draggable={false}
          />
        ) : (
          <span className="block h-2.5 w-2.5 rounded-full bg-charcoal" />
        )}
      </div>
    </div>
  );
};
